import { I18nString } from '@lifk/types'

export const layerCategories: Record<string, I18nString> = {
  metric: { english: 'Metric', spanish: 'Métrico' },
  feature: { english: 'Feature', spanish: 'Característica' },
  boundary: { english: 'Boundary', spanish: 'Límite' }
}
